import apiClient from './client';
import { nonce, profileVisitsLogApiUrl, profileVisitsMeApiUrl } from '../utils/runtime';

function buildNoCacheUrl(url) {
  if (!url) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_pfp_ts=${Date.now()}`;
}

export async function logProfileVisit(visitedSlug, source = 'public_profile') {
  const url = profileVisitsLogApiUrl || '/wp-json/pfandpirat/v1/profile-visits/log';
  return apiClient.post(url, { visited_slug: visitedSlug, source });
}

export async function fetchMyProfileVisits(limit = 6) {
  const baseUrl = profileVisitsMeApiUrl || '/wp-json/pfandpirat/v1/profile-visits/me';
  const query = new URLSearchParams({ limit: String(limit) });
  const url = buildNoCacheUrl(`${baseUrl}?${query.toString()}`);

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
    headers: {
      'X-WP-Nonce': nonce,
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
    },
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    const message =
      (data && typeof data === 'object' && (data.message || data.error)) ||
      `HTTP ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.payload = data;
    throw err;
  }

  return data;
}

export default {
  logProfileVisit,
  fetchMyProfileVisits,
};
